module.exports = __webpack_public_path__ + "img/nan.2584b1c1.png";